import { commonPopupStyle } from '../../styles/common-style';
import { customElement, property, queryAll, state } from 'lit/decorators';
import { DeviceAwareComponent } from '../components/device-aware-component';
import { LayoutBlock } from '@FLAVOR/../../common/types';
import { DepInjMixin, requires } from '../../mixins/dependency';
import { QuestionsService } from '../../services/questions-service';
import { css, html } from 'lit';
import { InfoDuotone } from '@APP/views/icons/icons';

type OwnDeps = {
  questionsService: QuestionsService;
};


@requires(QuestionsService.serviceName)
@customElement('section-layout-popup')
export class SectionLayoutPopup extends DepInjMixin<OwnDeps>(DeviceAwareComponent) {
  static get baseStyles() {
    return [
      commonPopupStyle,
      css`
        #question-text {
          font-size: 1.35em;
          font-weight: normal;
      }

      :host {
        text-align: left;
        max-height: 55vh;
        overflow-y: auto;
        overflow-x: hidden;
      }

      .title {
        font-size: 3rem;
        font-weight: var(--font-weight-emphasize);
        margin-block-end: 3rem;
        margin-top: 0;
      }


      .info {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 1rem 2rem;
        gap: 1rem;

        font-weight: 500;
        font-size: 2rem;
        line-height: 1.5;
        color: #0D2D5F;

        border: 1px solid rgba(58, 106, 162, 0.5);
        border-radius: 1rem;
        max-width: 80rem;
      }

      .contact {
        display: flex;
        align-items: center;
        padding: 1em 0;
        color: #0D2D5F;
        font-size: 2.5rem;
        font-weight: 500;
      }

      .star {
        background-image: url('assets/starfish.svg');
        width: 4.7rem;
        height: 4.7rem;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        display: inline-block;
        position: relative;
        margin-right: 2rem;
      }

      @media screen and  (max-width: 300px) {
        #art {
          height: 20rem;
        }
      }
    `,
    ];
  };

  static get mobileStyles() {
    return [
      css`
        :host {
          --answer-label-top-padding: 0;
          --maxH: 1;
        }
     
        :host(.look-like-regular-section) {
          max-height: 77vh;
          margin-top: 2rem;
        }
        
        lh-question-group {
          max-height: 100%;
          overflow-y: auto;
          overflow-x: hidden;
        }
    `,
    ];};

  @property({ type: Object })
    sectionLayoutPopupData: any = {};

  @state()
    section = '';

  @state()
    shouldLookLikeRegularSection = false;

  @queryAll('lh-question-group')
  private questionElements!: any[];

  private layout: LayoutBlock = [];

  public isValid: boolean = false;

  connectedCallback() {
    super.connectedCallback();
    const { section, shouldLookLikeRegularSection } = this.sectionLayoutPopupData;
    this.section = section;
    this.shouldLookLikeRegularSection = shouldLookLikeRegularSection;
  }

  public runValidationsNow() {
    Array.from(this.questionElements).forEach((el) => el.runValidationsNow());
  }

  public updateShowErrors() {
    Array.from(this.questionElements).forEach((el) => el.updateShowErrors());
  }

  public checkValidations() {
    Array.from(this.questionElements).forEach((el) => el.checkValidations());
    this.isValid = Array.from(this.questionElements).every((el) => el.isValid || el.hidden);
  }

  public getErrors(): string {
    return Array.from(this.questionElements).map((el) => el.getErrors()).filter(i => i != '').join(', ');
  }

  renderContent() {

    if (this.section === 'S_NoKnownLoss') {
      return this.renderNkllContent();
    }
    this.layout = this.deps.questionsService.model.getLayoutGrouping(this.section)[0];

    return html`
      <style>
        :host {
          --answer-label-top-padding: 0;
        }
      </style>
      <lh-question-group .section=${this.section} .noTilte=${this.shouldLookLikeRegularSection} .layout=${this.layout}></lh-question-group>
    `;
  }

  renderNkllContent() {
    this.layout = this.deps.questionsService.model.getLayoutGrouping(this.section)[0];
    const supportPhoneNumber = this.deps.questionsService.model.getSupportNumber();
    return html`
      <div class="info">
        ${InfoDuotone}
        In order to bind a policy effective the coming two days, you'll need to sign the below "No Known Loss" Letter.
      </div>
      <lh-question-group .noTilte=${this.shouldLookLikeRegularSection} .layout=${this.layout} class="card"></lh-question-group>
      <div class="contact">
        <span class="star"></span>
        For more information If you have any questions or concerns, <br/>
        please contact Ahoy! Insurance at ${supportPhoneNumber}.
      </div>
    `;
  }

}